import { render, staticRenderFns } from "./VolunteerMatchNetConfirm.vue?vue&type=template&id=533f0a46"
import script from "./VolunteerMatchNetConfirm.vue?vue&type=script&lang=ts"
export * from "./VolunteerMatchNetConfirm.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerMatchNetConfirm.vue?vue&type=style&index=0&id=533f0a46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports